import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getAssetLevelById,
  modifyAssetLevel,
  modifyCustomField, //Groups
  addAssetLevel,
  updateAssetLevel,
} from 'asset_level/actions';

import { getEditing } from 'asset_level/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups
import { getRoles } from 'roles/actions'; //Groups

import { valueFromEvent, createRoute } from 'lib/util';

class AssetLevelFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { pid } = this.props.match.params;
    this.props.reset();
    pid && this.props.getById(pid, this.props.company.id, this.props.subcompany.id);
    const filtersRoles = { limit: 100 };
    this.props.getRoles(this.props.company.id, this.props.subcompany, filtersRoles);
    //Groups
    // this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    // const filters = { fulltext: "proyecto", columnSearch: ["module"] };
    // this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.asset_level.id
          ? this.props.update(
              this.props.asset_level.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.asset_level
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.asset_level);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'asset_level')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  //handleValueChange = e => this.props.modify(valueFromEvent(e));

  handleValueChange = (e) => {
    let payload = valueFromEvent(e);
    payload = Object.keys(payload).reduce((re, k) => {
      if (k.indexOf('max_time') > -1) {
        re[k] = parseFloat(payload[k]);
        re[k] = re[k] || '';
      } else {
        re[k] = payload[k];
      }
      return re;
    }, {});

    this.props.modify(payload);
  };

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups

  handleValidation = (isValid) => this.setState({ isValid });

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  asset_level: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addAssetLevel,
  error: addGrowlError,
  getById: getAssetLevelById,
  modify: modifyAssetLevel,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  getRoles: getRoles, //Roles
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateAssetLevel,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetLevelFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/containers/AssetLevelFormHandlers.js